import { Injectable } from '@angular/core';
import { merge, Observable } from 'rxjs';

import { Dietitian } from './data/dietitian/domain/dietitian';
import { DietitianCommands } from './data/dietitian/domain/dietitian_commands';
import {
  DietitianState,
  DietitianStateProvider,
} from './data/dietitian/domain/dietitian_state_provider';
import { SubscriptionCommands } from './data/dietitian/domain/subscription/subscription_commands';
import { BillParamsRepository } from './data/dietitian/repositories/bill-params.repository';
import { FeatureRepository } from './data/dietitian/repositories/feature.repository';
import { NewsCommands } from './data/news/domain/news-commands';
import { PatientCommands } from './data/patient/domain/patient_commands';

@Injectable()
export class AppFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private dietitianCommands: DietitianCommands,
    private patientCommands: PatientCommands,
    private subscriptionCommands: SubscriptionCommands,
    private newsCommands: NewsCommands,
    private featureRepository: FeatureRepository,
    private billParamsRepository: BillParamsRepository,
  ) {
    // do nothing
  }

  get dietitian$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$.pipe();
  }

  listenSubscription(subscriptionId: string) {
    return this.subscriptionCommands.listenSubscription(subscriptionId);
  }

  listenEInvoicingParams(dietitianId: string) {
    return merge(
      this.dietitianCommands.listenDietitian(dietitianId),
      this.billParamsRepository.listenBillParams(dietitianId),
    );
  }

  loadCurrentDietitian() {
    return this.dietitianCommands.loadCurrentDietitian();
  }

  getCurrentDietitian() {
    return this.dietitianCommands.getCurrentDietitian();
  }

  loadCurrentPatient() {
    return this.patientCommands.loadCurrentPatient();
  }

  getCurrentPatient() {
    return this.patientCommands.getCurrentPatient();
  }

  async findAllNewsAfterDate(after: Date) {
    return this.newsCommands.findAllAfterDate(after);
  }

  async findLastTwoNews() {
    return this.newsCommands.findLastTwoNews();
  }

  async updateDietitianLastNews(): Promise<Dietitian> {
    return this.dietitianCommands.updateCurrentDietitianLastNews();
  }

  async findActiveBilling() {
    return this.featureRepository.findActiveByCode('billing');
  }

  async getBillParams(dietitianId: string) {
    return this.billParamsRepository.load(dietitianId);
  }
}
